var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDashcardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 193,
    height: 120
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.297,
    width: 192.381,
    height: 118.703,
    rx: 8,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "#24292f",
    fillOpacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.735 94.144C18.277 69.212-15.941 69.504-32.12 73.66c-3.113.8-5.052 3.714-5.09 6.928l-.899 74.605a8 8 0 0 0 7.903 8.096l240.585 2.897a8.01 8.01 0 0 0 8.094-7.556l.044-.772c1.718-30.3 3.818-67.334-2.877-57.932-9.165 12.871-100.263 29.122-156.906-5.783Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.749 100.604c-63.476-28.577-104.204-12.748-119.675 1.048-2.067 1.844-2.64 4.754-1.828 7.402l42.92 139.998a8 8 0 0 0 9.993 5.304l287.409-88.113a7.994 7.994 0 0 0 5.377-9.757c-14.78-53.969-33.989-125.583-36.861-105.954-3.758 25.69-101.857 88.555-187.335 50.072Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.236 85.595c41.451-33.568 76.134-32.011 91.905-25.873 2.675 1.041 4.195 3.745 4.195 6.616v106.06a8 8 0 0 1-8 8H-26.181a8.006 8.006 0 0 1-8.002-7.743c-1.367-41.533-3.323-94.987 3.454-81.802 9.01 17.527 99.905 40.948 156.965-5.258Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDashcardBg);
export default __webpack_public_path__ + "static/media/image_dashcard_bg.449b0e8ea4cf1677420324ef34ca0a66.svg";
export { ForwardRef as ReactComponent };